module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/search-eb4d96c2ce3701c7e33b818bce504d16.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/search.svg
// module id = VMXF
// module chunks = 24